import React, { Component } from 'react'
//import axios from "axios";

import Header from './Header';
import Footer from './Footer';
import Table from 'react-bootstrap/Table'

export class AuthorizedDealers extends Component {
    constructor(props) {    
        super(props);    
        this.state = {
            users: [],
            loading:true
          }
        
    }

    async getUsersData(){
        const res = [
           /* {
              "id": 1,
              "Dealer_Name": "Achariya Technologies Pvt. Ltd.",
              "Dealer_Hq": "Hisar",
              "State_Assigned":"Haryana",
              "Districts_Assigned":"All Districts",
              "Contact_Person": "Virendra Bhyan",
              "Mobile_1": "9034040247",
              "Mobile_2": "7230003324",
              "Email_1": "accachariyahisar@gmail.com",
              "Email_2": "manager.rkcl@achariyagroup.com",
            },
            {
                "id": 2,
                "Dealer_Name": "Agarwal Education Services Pvt. Ltd.",
                "Dealer_Hq": "Bhilwara",
                "State_Assigned":"Rajasthan",
                "Districts_Assigned":"Bhilwara/Ajmer/Nagaur/ Rajsamand/Chittorgarh",
                "Contact_Person": "Abhishek Lohiya/Dilip",
                "Mobile_1": "8854022000",
                "Mobile_2": "9549898829",
                "Email_1": "bhilwara.college@gmail.com",
                "Email_2": "abhishek.aesplindia@gmail.com",
              },*/
              {
                "id": 3,
                "Dealer_Name": "Chordia Infotech",
                "Dealer_Hq": "Churu",
                "State_Assigned":"Rajasthan",
                "Districts_Assigned":"Churu/Bikaner/Sikar/ Jhunjhunu/SriGanganagar/ Hanumangarh",
                "Contact_Person": "Vinod Kumar/ Puneet Chordia",
                "Mobile_1": "9799855860",
                "Mobile_2": "9414894278",
                "Email_1": "chordiaschooleasy@gmail.com",
                "Email_2": "puneet_mcc@yahoo.in",
              },
              /*{
                "id": 4,
                "Dealer_Name": "COMPUTER INSTITUTE OF NEW - GEN (CING)",
                "Dealer_Hq": "Jodhpur",
                "State_Assigned":"Rajasthan",
                "Districts_Assigned":"Jodhpur/Pali/Barmer/ Jalore/Sirohi/Jaisalmer",
                "Contact_Person": "Vivek Sharma",
                "Mobile_1": "7597273004",
                "Mobile_2": "9314210436",
                "Email_1": "cingjodhpur@gmail.com",
                "Email_2": "",
              },
              {
                "id": 5,
                "Dealer_Name": "Everest Technical Education Pvt. Ltd.",
                "Dealer_Hq": "Udaipur",
                "State_Assigned":"Rajasthan",
                "Districts_Assigned":"Udaipur/Rajsamand/ Chittorgarh/Banswara/ Dungarpur",
                "Contact_Person": "JINENDRA VANAWAT/Piyush",
                "Mobile_1": "8003699621",
                "Mobile_2": "9636049901",
                "Email_1": "vanawatj@gmail.com",
                "Email_2": "",
              },
              {
                "id": 6,
                "Dealer_Name": "H.K. Hitech Trust",
                "Dealer_Hq": "Jodhpur",
                "State_Assigned":"Rajasthan",
                "Districts_Assigned":"Jodhpur/Pali/Barmer/ Jalore/Sirohi/Jaisalmer",
                "Contact_Person": "Sharad Choudhary/Rajesh",
                "Mobile_1": "9414195051",
                "Mobile_2": "9414914850",
                "Email_1": "hkhcollegejodhpur@gmail.com",
                "Email_2": "",
              },
              {
                "id": 7,
                "Dealer_Name": "RKCL Head Office",
                "Dealer_Hq": "Jaipur",
                "State_Assigned":"Rajasthan",
                "Districts_Assigned":"Jaipur/Alwar/Kota/Dausa",
                "Contact_Person": "Ankur Shekhawat",
                "Mobile_1": "9352363539",
                "Mobile_2": "9649900913",
                "Email_1": "ankurs@rkcl.in",
                "Email_2": "bishalc@rkcl.in",
              },*/
              {
                "id": 8,
                "Dealer_Name": "Swarn S Deora",
                "Dealer_Hq": "Jaipur",
                "State_Assigned":"Rajasthan",
                "Districts_Assigned":"Jaipur",
                "Contact_Person": "Swarn S Deora",
                "Mobile_1": "9828615143",
                "Mobile_2": "",
                "Email_1": "deoraswarn@gmail.com",
                "Email_2": "",
              },
              /*{
                "id": 8,
                "Dealer_Name": "Dash Skill EduTrain Pvt. Ltd.",
                "Dealer_Hq": "Bharatpur",
                "State_Assigned":"Rajasthan",
                "Districts_Assigned":"Bharatpur/Dholpur",
                "Contact_Person": "Dinesh Kumar/Hemendra",
                "Mobile_1": "9829034933",
                "Mobile_2": "9414271977",
                "Email_1": "dashspbharatpur@gmail.com",
                "Email_2": "dashinfo4u@gmail.com",
              },
              {
                "id": 9,
                "Dealer_Name": "VRJ Skills",
                "Dealer_Hq": "Paota tehsil of Jaipur",
                "State_Assigned":"Rajasthan",
                "Districts_Assigned":"4 Jaipur tehsils (Kotputli, Shahpura, Paota, ViratNagar)",
                "Contact_Person": "Jitendra Kumar Yadav",
                "Mobile_1": "8233582220",
                "Mobile_2": "",
                "Email_1": "teamvrj@gmail.com",
                "Email_2": "",
              },*/
              
        ]
        //console.log(res)
        this.setState({loading:false, users: res})
      }
      componentDidMount(){
        this.getUsersData()
      } 
    render() {
        /* const columns = [
            {  
            Header: 'S.No.',  
            accessor: 'id',
            
           }
           ,{  
            Header: 'Dealer Name',  
            accessor: 'Dealer_Name' ,
            }
           ,{  
           Header: 'Dealer HQ',  
           accessor: 'Dealer_Hq' ,
           },
           {  
            Header: 'State Assigned',  
            accessor: 'State_Assigned' ,
            },
            {  
             Header: 'Districts Assigned',  
             accessor: 'Districts_Assigned' ,
             },
             {  
              Header: 'Contact Person',  
              accessor: 'Contact_Person' ,
              },
              {  
               Header: 'Mobile 1',  
               accessor: 'Mobile_1' ,
               },
               
              {  
                Header: 'Mobile 2',  
                accessor: 'Mobile_2' ,
                },
                
              {  
                Header: 'Email 1',  
                accessor: 'Email_1' ,
                },
                
              {  
                Header: 'Email 2',  
                accessor: 'Email_2' ,
                },
        ]; */
        //console.log(this.state.users);
        let authorizedDetails =[];
        let s_no = 1;
        let authorized = this.state.users;
        if (authorized.length) {
            authorizedDetails = authorized.map((authorized) => {
              
              return (
                <tr>
                    <td>{s_no++}</td>
                    <td>{authorized.Dealer_Name}</td>	
                    <td>{authorized.Dealer_Hq}</td>
                    <td>{authorized.State_Assigned}</td>
                    <td>{authorized.Districts_Assigned}</td>
                    <td>{authorized.Contact_Person}</td>
                    <td>{authorized.Mobile_1}</td>
                    <td>{authorized.Mobile_2}</td>
                    <td>{authorized.Email_1}</td>
                    <td>{authorized.Email_2}</td>
                </tr>
              );
            });
          }
        return ( 
            <div>
      	    <Header/>
              <div className="container pb-5">
                    <section className="guest_opinion pt-5">
                        <h3 className="text-center pb-4 font-weight-bold title">authorized Dealers</h3>
                        <div class="row table-responsive" id="dealer">
                        
                        
                        <Table striped className="table dealer-table-bordered">
                        <thead><tr>
                            <th><strong>S.No.</strong></th>
                            <th><strong>Dealer Name</strong></th>
                            <th><strong>Dealer HQ</strong></th>
                            <th><strong>State Assigned</strong></th>
                            <th><strong>Districts Assigned</strong></th>
                            <th><strong>Contact Person</strong></th>
                            <th><strong>Mobile 1</strong></th>
                            <th><strong>Mobile 1</strong></th>
                            <th><strong>Email 1</strong></th>
                            <th><strong>Email 2</strong></th>
                            </tr></thead>
                            <tbody>{authorizedDetails} </tbody>
                           </Table>
                        </div>
                        
                        
                        
                    </section>
                </div>


            <Footer />

            </div>
        )
    }
}

export default AuthorizedDealers
